import { render } from "./TelemetrySettingsSection.vue?vue&type=template&id=3fdbc203"
import script from "./TelemetrySettingsSection.vue?vue&type=script&lang=js"
export * from "./TelemetrySettingsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__